
export class CalendarTemplate
{
    public calendarTemplateId: number;
    public calendarTemplateName: string;
    public calendarTemplateDescription: string;
    public providerId: string;
    public locationId: number;
    public createdOn: Date;
    public createdBy: string;
    public modifiedOn: Date;
    public modifiedBy: string;
    public isActive: boolean;
    public calendarTemplatesDays: CalendarTemplateDay[];
    public providerName: string;
    public locationName: string;
    public templateColor: string;
    public recurrence: string;
}

export class CalendarTemplateDay
{
    public CTDayId: number;

    public calendarTemplateId: number;
    public dayofweek: string;
    public startTime: string; // Date;
    public endTime: string; //Date;
    public cDate:string;//Date;
    public cDateTo:string;// Date;
    public visitCategoryId: number;
    public visitCategoryName: string;
    public visitText: string;
    public visitTypeId: number;
    public bookinglimit: number;
    public  patName: string;
    public  isScheduled : boolean;
    public  dob : string;
    public  patId : number;
    public  title : string;
    public providerName: string;
    public  backgroundColor : string;
    public providerId: string;
    public locationId: number;
    public id: string;
    public isActive : boolean;
    public  encounterId  : string;
    public appStatus : string;
    public duration : number
    public daysselected:string[]
}
